import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { GuideAuthorDetails } from '../../@types/Wordpress';
import { formatDate } from '../../utilities/WordPress.helpers';

import LocalTexts from './ContentAuthors.texts.json';

import styles from './ContentAuthors.module.scss';

const LocalT = new MDText(LocalTexts);

type ContentAuthorsProps = {
  author: GuideAuthorDetails;
  editor?: string;
  modifiedDateTime?: string;
};

export const ContentAuthors: React.FC<ContentAuthorsProps> = ({ author, editor, modifiedDateTime }) => {
  const { id, name, thumbnail } = author;

  const formattedDate = formatDate(modifiedDateTime);

  const authorLink = <Hyperlink href={`/guides/authors/${id}`} label={name} size='small'/>;

  return <div className={styles.contentAuthors}>
    <div className={styles.info}>
      {thumbnail && <div className={styles.imageWrapper}>
        <img
          key={name}
          alt={name}
          className={styles.image}
          height="40"
          loading="lazy"
          src={thumbnail}
          width="40"
        />
      </div>}
      <div className={styles.text}>
        <p data-thc-style-override className={styles.author}>{LocalT.translate('author', { authorLink })}</p>
        {editor && <p data-thc-style-override className={styles.editor}>{LocalT.translate('editor', { editor })}</p>}
      </div>
    </div>
    {formattedDate && <time className={styles.modifiedDateTime} dateTime={modifiedDateTime}>{LocalT.translate('modifiedDateTime', { date: formattedDate })}</time>}
  </div>;
};
